import { Outlet } from "react-router";
import { Navbar } from "./Navbar";
import { Footer } from "./Footer";
import { ScrollToTop } from "./ScrollToTop";
import { Toaster } from "sonner";
import { WhatsAppButton } from "./WhatsAppButton";

export function Layout() {
  return (
    <div className="flex flex-col min-h-screen font-sans text-slate-800 bg-white selection:bg-[#FD5750] selection:text-white">
      <Toaster position="top-right" richColors />
      <ScrollToTop />
      <Navbar />
      <main className="flex-grow relative">
        <Outlet />
        <WhatsAppButton />
      </main>
      <Footer />
    </div>
  );
}
